module.exports = __webpack_public_path__ + "static/media/drug_card.39f58f99.svg";